// @flow

import React, {Component} from "react"
import {injectIntl} from "react-intl"
import {Select} from 'formsy-react-components'
import {connect} from "react-redux"
import {ACTION_QUERY_EDUCATION_LIST_LOADING} from '../../constants'
import educations from './wrongEductions.json'

import type {Education} from '../../types'

function mapStateToProps(state, ownProps) {

  const educations = state.educations || {data:[]}
  return {
    educations
  }
}

const mapDispatchToProps = {
  queryData: function () {
    return {
      type: ACTION_QUERY_EDUCATION_LIST_LOADING
    }
  }
}


class EducationSelect extends Component {

  props:{
    name: string,
    value: string,
    required: boolean,
    intl:{
      formatMessage: ({})=>string
    },
    queryData: ()=>void
  }

  componentWillMount() {
    this.props.queryData()
  }

  render() {

    const format = this.props.intl.formatMessage

    const data: Array<Education> = educations // this.props.educations.data

    const options = data.map(
      (c:Education)=>
        ({
          value: c.code,
          label: format({id:`education.${c.code}`})
        })
    )

    return (
      <Select name={this.props.name}
              label={format({id: 'input.label.education'})}
              value={this.props.value}
              options={[{value:'', label:format({id:'input.label.education.default'})},...options]}
              required={this.props.required}
              {...this.props}
      >
      </Select>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EducationSelect))



// WEBPACK FOOTER //
// ./src/components/form/EducationSelect.js